import { useState } from "react"
import { Button, Menu, MenuItem } from "@mui/material"
import { NavLink } from "react-router-dom"
import { StyledFontAwesomeIconForButton } from "shared/styled/General"

type MenuItemType = {
    label: string
    to?: string
    onClick?: () => void
}

type DropdownMenuProps = {
    startIcon?: React.ReactNode
    endIcon?: React.ReactNode
    t: (key: string, fallback: string) => string
    buttonLabel: string
    items: MenuItemType[]
}

export default function DropdownMenu({
    t,
    buttonLabel,
    startIcon,
    endIcon,
    items,
}: DropdownMenuProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <>
            <Button variant="outlined" color="secondary" onClick={handleClick}>
                {startIcon && <StyledFontAwesomeIconForButton icon={startIcon} />}
                {buttonLabel}
                {endIcon && <StyledFontAwesomeIconForButton icon={endIcon} />}
            </Button>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {items.map((item, index) => {
                    const handleItemClick = () => {
                        handleClose()
                        if (item.onClick) {
                            item.onClick()
                        }
                    }

                    return item.to ? (
                        <MenuItem
                            key={index}
                            component={NavLink}
                            to={item.to}
                            onClick={handleClose}
                        >
                            {item.label}
                        </MenuItem>
                    ) : (
                        <MenuItem key={index} onClick={handleItemClick}>
                            {item.label}
                        </MenuItem>
                    )
                })}
            </Menu>
        </>
    )
}
